import { render, staticRenderFns } from "./ProjectEditExtraOptionsTab.vue?vue&type=template&id=15e87873"
import script from "./ProjectEditExtraOptionsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectEditExtraOptionsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports